/* eslint-disable no-restricted-exports */
import type { UseStorageOptions } from "@vueuse/core";

export default <T>(
    name: string,
    defaultValue: T,
    options?: UseStorageOptions<T>,
    // eslint-disable-next-line unicorn/no-anonymous-default-export
) => {
    const { slug } = storeToRefs(useSlugStore());

    return useLocalStorage(
        `${slug.value ?? "*"}.${name}`,
        defaultValue,
        options,
    );
};
